import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeletePricingPlanTierFormModal from 'src/features/pricingPlan/components/form/tiers/DeletePricingPlanTierFormModal';
import UpdatePricingPlanTierFormModal from 'src/features/pricingPlan/components/form/tiers/UpdatePricingPlanTierFormModal';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { PricingPlanTier } from 'src/features/pricingPlan/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface Props extends CellContext<PricingPlanTier, unknown> {
    isPricingPlanPublished: boolean;
}

export default function CellTierActions({ row, isPricingPlanPublished }: Props) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <UpdatePricingPlanTierFormModal
                                selectedTier={row.original}
                                semantics={{ entryName: formatMessage(pricingPlanMessages.tier).toLowerCase() }}
                            >
                                <Button
                                    size="icon"
                                    variant="link"
                                    className="cursor-pointer hover:bg-gray-100"
                                    disabled={isPricingPlanPublished}
                                >
                                    <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                </Button>
                            </UpdatePricingPlanTierFormModal>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage
                            {...(isPricingPlanPublished
                                ? pricingPlanMessages.publishedPricingPlanError
                                : generalMessages.edit)}
                        />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <DeletePricingPlanTierFormModal selectedTier={row.original}>
                                <Button
                                    size="icon"
                                    variant="link"
                                    className="cursor-pointer hover:bg-gray-100"
                                    disabled={isPricingPlanPublished}
                                >
                                    <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                </Button>
                            </DeletePricingPlanTierFormModal>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage
                            {...(isPricingPlanPublished
                                ? pricingPlanMessages.publishedPricingPlanError
                                : generalMessages.delete)}
                        />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
